import MonthlyScopeGapForecast from '@/models/MonthlyScopeGapForecast';
import ScopeGap from '@/models/ScopeGap';
import ScopeGapCategory from '@/models/ScopeGapCategory';
import ScopeGapItem from '@/models/ScopeGapItem';
import ScopeGapService from '@/services/ScopeGapService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useScopeGapsStore = defineStore('scope_gaps', {
  getters: {
    models: () => useRepo(ScopeGap),
  },

  actions: {
    async index(projectId: Id, packageId: Id) {
      const [data, error] = await ScopeGapService.index(projectId, packageId);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async show(scopeGapId: Id) {
      const [data, error] = await ScopeGapService.show(scopeGapId);

      if(error) {
        throw error;
      }

      this.models.save(data.scope_gap);

      if(data.previous_scope_gap) {
        this.models.save(data.previous_scope_gap);
      }

      return data;
    },

    async store(projectId: Id, packageId: Id, request: ApiRequests['api.v1.scope-gaps.store']) {
      const [data, error] = await ScopeGapService.store(projectId, packageId, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },
  },
});
